import { jsx as _jsx } from "react/jsx-runtime";
const riskColours = {
    low: 'bg-green-500',
    medium: 'bg-amber-500',
    high: 'bg-orange-500',
    critical: 'bg-red-500',
};
export function RiskMatrix({ tools }) {
    const counts = { low: 0, medium: 0, high: 0, critical: 0 };
    tools.forEach(t => counts[t.riskLevel]++);
    const total = tools.length || 1;
    return (_jsx("div", { className: "flex gap-1 h-6 rounded-md overflow-hidden", children: ['low', 'medium', 'high', 'critical'].map(level => counts[level] > 0 ? (_jsx("div", { className: `${riskColours[level]} flex items-center justify-center text-xs text-white font-medium`, style: { width: `${(counts[level] / total) * 100}%` }, children: counts[level] }, level)) : null) }));
}
